import { RegionSelectValueType, OptionsItemType, ChildrenItemType } from './type';
import React, { useMemo } from 'react';
import { LOCALE_CN, VALUE_TYPE_REGION } from './config';
import './RegionSelectButton.scss';
import { FormatMessageOptionType } from './useLocale';
import { getText } from '@/pages/home/components/NewRegionSelect/util';
import { getCountryFlag } from '@/pages/home/_config/countries';

interface ButtonPropsType {
  value: RegionSelectValueType | null;
  options: OptionsItemType[];
  allChildren: ChildrenItemType[];
  radioOptions?: OptionsItemType[];
  formatMessage: (option: FormatMessageOptionType) => string;
  locale: string;
  selectFilterType?: string;
  placeholder?: string;
}

export default (props: ButtonPropsType) => {
  const {
    value,
    options,
    allChildren,
    radioOptions,
    formatMessage,
    selectFilterType = 'region',
    locale,
    placeholder
  } = props;

  // console.log('ButtonPropsType', props);

  const render = useMemo(() => {
    const { type = '', regions = [], markets = [] } = value || {};
    const titleRegion = placeholder || formatMessage({ id: 'button_region' });
    const titleMarket = placeholder || formatMessage({ id: 'button_market' });

    if (selectFilterType === 'event_parameter' && markets?.length > 0) {
      const paramParts: string[] = [];
      // 找出所有有选中子项的父项
      const usedRegions = options.filter(o => o.children?.some(c => markets.includes(c.value)));
      
      usedRegions.forEach((regionOption: OptionsItemType) => {
        const regionValue = regionOption.value;
        const regionText = getText(regionOption, locale) || regionValue;
        const childValues = markets.filter((market: string) => {
          return regionOption.children?.some(c => c.value === market);
        });
        if (childValues.length > 0) {
          const childTexts = childValues.map((cv: string) => {
            const child = regionOption.children?.find(c => c.value === cv);
            return getText(child, locale) || cv;
          });
          paramParts.push(`${regionText}=${childTexts.join('&')}`);
        }
      });
      if (paramParts.length > 0) {
        return <span className='select-button-value'>{paramParts.join(', ')}</span>;
      }
      return <span className="select-button-text">{titleRegion}</span>;
    }

    if (type === VALUE_TYPE_REGION) {
      if (regions.length === 1) {
        const findRegion = options.find(item => item.value === regions[0]);
        // return <>
        //   <span className="select-button-text">{titleRegion}</span>
        //   <span className='select-button-value'>{getText(findRegion, locale) || regions[0]}</span>
        // </>

        if (markets?.length === 1) {
          const oneMarket = markets[0];
          const findMarket = allChildren.find(item => item.value === oneMarket);
          return <>
            <span className="select-button-text">{titleRegion}</span>
            {findMarket?.icon && <img className="dbc-region-select-item-icon" src={findMarket.icon} alt="" />}
            <span className='select-button-value'>{getText(findMarket, locale) || oneMarket}</span>
          </>
        } else {
          return <>
            <span className="select-button-text">{titleRegion}</span>
            <span className='select-button-value'>{getText(findRegion, locale) || regions[0]}</span>
          </>
        }
      }

      return <>
        <span className="select-button-text">{titleRegion}</span>
        <span>{regions.length || ''}</span>
      </>
    }

    if (markets?.length === 1) {
      const oneMarket = markets[0];
      const findRadio = radioOptions?.find(item => item.value === oneMarket);
      if (findRadio) {
        return <>
          <span className="select-button-text">{titleRegion}</span>
          <span className='select-button-value'>{(locale === LOCALE_CN ? findRadio?.textCN : findRadio?.text) || oneMarket}</span>
        </>
      }

      const findMarket = allChildren.find(item => item.value === oneMarket);
      return <>
        <span className="select-button-text">{titleMarket}</span>
        {findMarket?.icon && <img className="dbc-region-select-item-icon" src={findMarket.icon} alt="" />}
        <span className='select-button-value'>{getText(findMarket, locale) || oneMarket}</span>
      </>
    }

    return <>
      <span className="select-button-text">{titleMarket}</span>
      <span>{markets?.length || ''}</span>
    </>
  }, [value, options, allChildren, radioOptions, formatMessage, selectFilterType, locale, placeholder]);


  return (
    <div className="dbc-region-select-button-wrap" id={`${selectFilterType}-input`}>{render}</div>
  );
};
